<ng-template #settingsTemplate>
    <app-tool-setting label="Nummers per rij">
        <app-radio-input
            [value]="3"
            [model]="numsPerRow"
            (selected)="setNumsPerRow(3)"
            >3 getallen per rij</app-radio-input
        >
        <app-radio-input
            [value]="4"
            [model]="numsPerRow"
            (selected)="setNumsPerRow(4)"
            >4 getallen per rij</app-radio-input
        >
    </app-tool-setting>
    <app-tool-setting label="Vul in">
        <app-numbers-input
            (numberChoice)="handleNumberChoice($event)"
            (undo)="handleUndo()"
            (clear)="handleClear()"
        ></app-numbers-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    @if (numsPerRow === 3) {
    <svg
        id="Laag_1"
        data-name="Laag 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-45 0 280 280"
        style="height: 280px"
    >
        <defs>
            <style>
                .mTriangle3-1,
                .mTriangle3-4,
                .mTriangle3-5 {
                    fill: none;
                }
                .mTriangle3-1 {
                    stroke: #1d1d1b;
                }
                .mTriangle3-1,
                .mTriangle3-2 {
                    stroke-width: 1.5px;
                }
                .mTriangle3-2 {
                    fill: #fff;
                    stroke: #0090c9;
                }
                .mTriangle3-3 {
                    font-size: 26px;
                    font-family: UniversLTStd, Univers LT Std;
                }
                .mTriangle3-4,
                .mTriangle3-5 {
                    stroke: #a1a1a1;
                }
                .mTriangle3-5 {
                    stroke-width: 1px;
                }
            </style>
        </defs>
        <polygon
            class="mTriangle3-1"
            points="24 142.65 92.48 23.97 161 142.65 24 142.65"
        />
        <g class="magic-triangle-item-fields">
            <g class="field1" (click)="setActiveField(0)">
                <path
                    class="mTriangle3-2"
                    d="M72.19,37A23.25,23.25,0,1,0,80.7,5.22,23.25,23.25,0,0,0,72.19,37Z"
                    transform="translate(0 -1.35)"
                />
                <text
                    class="mTriangle3-3"
                    text-anchor="middle"
                    transform="translate(91.75 33.84)"
                >
                    {{ values[0] }}
                </text>
                @if (activeField === 0) {
                <g>
                    <line
                        class="mTriangle3-5"
                        x1="76.32"
                        y1="37.83"
                        x2="108.32"
                        y2="37.83"
                    />
                </g>
                }
            </g>
            <g class="field2" (click)="setActiveField(1)">
                <path
                    class="mTriangle3-2"
                    d="M78.39,96.3a23.25,23.25,0,1,0-31.76,8.51A23.25,23.25,0,0,0,78.39,96.3Z"
                    transform="translate(0 -1.35)"
                />
                <text
                    class="mTriangle3-3"
                    text-anchor="middle"
                    transform="translate(56.75 92.84)"
                >
                    {{ values[1] }}
                </text>
                @if (activeField === 1) {
                <g>
                    <line
                        class="mTriangle3-4"
                        x1="41.91"
                        y1="96.83"
                        x2="73.83"
                        y2="96.83"
                    />
                </g>
                }
            </g>
            <g class="field3" (click)="setActiveField(2)">
                <path
                    class="mTriangle3-2"
                    d="M106.61,96.3a23.25,23.25,0,1,0,8.51-31.76A23.25,23.25,0,0,0,106.61,96.3Z"
                    transform="translate(0 -1.35)"
                />
                <text
                    class="mTriangle3-3"
                    text-anchor="middle"
                    transform="translate(125.75 92.84)"
                >
                    {{ values[2] }}
                </text>
                @if (activeField === 2) {
                <g>
                    <line
                        class="mTriangle3-4"
                        x1="111.23"
                        y1="96.83"
                        x2="143.15"
                        y2="96.83"
                    />
                </g>
                }
            </g>
            <g class="field4" (click)="setActiveField(3)">
                <path
                    class="mTriangle3-2"
                    d="M44.14,155.62a23.25,23.25,0,1,0-31.76,8.51A23.25,23.25,0,0,0,44.14,155.62Z"
                    transform="translate(0 -1.35)"
                />
                <text
                    class="mTriangle3-3"
                    text-anchor="middle"
                    transform="translate(22.75 151.84)"
                >
                    {{ values[3] }}
                </text>
                @if (activeField === 3) {
                <g>
                    <line
                        class="mTriangle3-4"
                        x1="7.91"
                        y1="155.83"
                        x2="39.83"
                        y2="155.83"
                    />
                </g>
                }
            </g>
            <g class="field5" (click)="setActiveField(4)">
                <path
                    class="mTriangle3-2"
                    d="M112.65,155.62a23.25,23.25,0,1,0-31.76,8.51A23.25,23.25,0,0,0,112.65,155.62Z"
                    transform="translate(0 -1.35)"
                />
                <text
                    class="mTriangle3-3"
                    text-anchor="middle"
                    transform="translate(91.25 151.84)"
                >
                    {{ values[4] }}
                </text>
                @if (activeField === 4) {
                <g>
                    <line
                        class="mTriangle3-4"
                        x1="75.91"
                        y1="155.83"
                        x2="107.83"
                        y2="155.83"
                    />
                </g>
                }
            </g>
            <g class="field6" (click)="setActiveField(5)">
                <path
                    class="mTriangle3-2"
                    d="M140.88,155.62a23.25,23.25,0,1,0,8.51-31.76A23.25,23.25,0,0,0,140.88,155.62Z"
                    transform="translate(0 -1.35)"
                />
                <text
                    class="mTriangle3-3"
                    text-anchor="middle"
                    transform="translate(159.75 151.84)"
                >
                    {{ values[5] }}
                </text>
                @if (activeField === 5) {
                <g>
                    <line
                        class="mTriangle3-4"
                        x1="145.23"
                        y1="155.83"
                        x2="177.15"
                        y2="155.83"
                    />
                </g>
                }
            </g>
        </g>
    </svg>
    } @if (numsPerRow === 4) {
    <svg
        id="Laag_1"
        data-name="Laag 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-10 0 280 280"
        style="height: 280px"
    >
        <defs>
            <style>
                .cls-1,
                .cls-3 {
                    fill: none;
                }
                .cls-1 {
                    stroke: #1d1d1b;
                }
                .cls-1,
                .cls-2 {
                    stroke-width: 1.5px;
                }
                .cls-2 {
                    fill: #fff;
                    stroke: #0090c9;
                }
                .cls-3 {
                    stroke: #a1a1a1;
                }
                .cls-4 {
                    font-size: 26px;
                    font-family: UniversLTStd, Univers LT Std;
                }
            </style>
        </defs>
        <polygon
            class="cls-1"
            points="23.37 201.88 126.47 23.2 229.63 201.88 23.37 201.88"
        />
        <g class="magic-triangle-item-fields">
            <g class="field1" (click)="setActiveField(0)">
                <path
                    class="cls-2"
                    d="M108,37.74A23.25,23.25,0,1,0,116.46,6,23.23,23.23,0,0,0,108,37.74Z"
                    transform="translate(-1 -2.12)"
                />
                <text
                    class="cls-4"
                    text-anchor="middle"
                    transform="translate(126.75 33.07)"
                >
                    {{ values[0] }}
                </text>
                @if (activeField === 0) {
                <g>
                    <line
                        class="cls-3"
                        x1="111.23"
                        y1="37.06"
                        x2="143.14"
                        y2="37.06"
                    />
                </g>
                }
            </g>
            <g class="field2" (click)="setActiveField(1)">
                <path
                    class="cls-2"
                    d="M113.64,97a23.25,23.25,0,1,0-31.76,8.51A23.25,23.25,0,0,0,113.64,97Z"
                    transform="translate(-1 -2.12)"
                />
                <text
                    class="cls-4"
                    text-anchor="middle"
                    transform="translate(92.75 93.07)"
                >
                    {{ values[1] }}
                </text>
                @if (activeField === 1) {
                <g>
                    <line
                        class="cls-3"
                        x1="76.91"
                        y1="97.06"
                        x2="108.83"
                        y2="97.06"
                    />
                </g>
                }
            </g>
            <g class="field3" (click)="setActiveField(2)">
                <path
                    class="cls-2"
                    d="M141.86,97a23.25,23.25,0,1,0,8.51-31.76A23.25,23.25,0,0,0,141.86,97Z"
                    transform="translate(-1 -2.12)"
                />
                <text
                    class="cls-4"
                    text-anchor="middle"
                    transform="translate(160.75 93.07)"
                >
                    {{ values[2] }}
                </text>
                @if (activeField === 2) {
                <g>
                    <line
                        class="cls-3"
                        x1="145.23"
                        y1="97.06"
                        x2="177.14"
                        y2="97.06"
                    />
                </g>
                }
            </g>
            <g class="field4" (click)="setActiveField(6)">
                <path
                    class="cls-2"
                    d="M79.39,156.3a23.25,23.25,0,1,0-31.76,8.51A23.25,23.25,0,0,0,79.39,156.3Z"
                    transform="translate(-1 -2.12)"
                />
                <text
                    class="cls-4"
                    text-anchor="middle"
                    transform="translate(57.75 152.07)"
                >
                    {{ values[6] }}
                </text>
                @if (activeField === 6) {
                <g>
                    <line
                        class="cls-3"
                        x1="41.91"
                        y1="156.06"
                        x2="73.83"
                        y2="156.06"
                    />
                </g>
                }
            </g>
            <g class="field5" (click)="setActiveField(7)">
                <path
                    class="cls-2"
                    d="M176.11,156.3a23.25,23.25,0,1,0,8.51-31.76A23.25,23.25,0,0,0,176.11,156.3Z"
                    transform="translate(-1 -2.12)"
                />
                <text
                    class="cls-4"
                    text-anchor="middle"
                    transform="translate(194.75 152.07)"
                >
                    {{ values[7] }}
                </text>
                @if (activeField === 7) {
                <g>
                    <line
                        class="cls-3"
                        x1="179.23"
                        y1="155.06"
                        x2="211.14"
                        y2="155.06"
                    />
                </g>
                }
            </g>
            <g class="field6" (click)="setActiveField(8)">
                <circle class="cls-2" cx="24" cy="201.88" r="23.25" />
                <text
                    class="cls-4"
                    text-anchor="middle"
                    transform="translate(23.75 211.07)"
                >
                    {{ values[8] }}
                </text>
                @if (activeField === 8) {
                <g>
                    <line
                        class="cls-3"
                        x1="7.91"
                        y1="215.06"
                        x2="39.83"
                        y2="215.06"
                    />
                </g>
                }
            </g>
            <g class="field7" (click)="setActiveField(9)">
                <circle class="cls-2" cx="92.5" cy="201.88" r="23.25" />
                <text
                    class="cls-4"
                    text-anchor="middle"
                    transform="translate(92.75 211.07)"
                >
                    {{ values[9] }}
                </text>
                @if (activeField === 9) {
                <g>
                    <line
                        class="cls-3"
                        x1="76.23"
                        y1="215.06"
                        x2="108.14"
                        y2="215.06"
                    />
                </g>
                }
            </g>
            <g class="field8" (click)="setActiveField(10)">
                <circle class="cls-2" cx="161" cy="201.88" r="23.25" />
                <text
                    class="cls-4"
                    text-anchor="middle"
                    transform="translate(160.75 211.07)"
                >
                    {{ values[10] }}
                </text>
                @if (activeField === 10) {
                <g>
                    <line
                        class="cls-3"
                        x1="145.23"
                        y1="215.06"
                        x2="177.14"
                        y2="215.06"
                    />
                </g>
                }
            </g>
            <g class="field9" (click)="setActiveField(11)">
                <circle class="cls-2" cx="229.5" cy="201.88" r="23.25" />
                <text
                    class="cls-4"
                    text-anchor="middle"
                    transform="translate(230.75 211.07)"
                >
                    {{ values[11] }}
                </text>
                @if (activeField === 11) {
                <g>
                    <line
                        class="cls-3"
                        x1="213.23"
                        y1="215.06"
                        x2="245.14"
                        y2="215.06"
                    />
                </g>
                }
            </g>
        </g>
    </svg>
    }
</ng-template>
